// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  formDataBodySerializer,
  type Options,
} from '@hey-api/client-fetch'

import type {
  CloneItemData,
  CloneItemError,
  CloneItemResponse,
  ContinueExportJobData,
  ContinueExportJobError,
  ContinueExportJobResponse,
  CreateAiModelData,
  CreateAiModelError,
  CreateAiModelResponse,
  CreateUserData,
  CreateUserError,
  CreateUserResponse2,
  DeleteAiModelsData,
  DeleteAiModelsError,
  DeleteAiModelsResponse,
  DeleteAuth0UsersData,
  DeleteAuth0UsersError,
  DeleteAuth0UsersResponse,
  DeleteFinetunesData,
  DeleteFinetunesError,
  DeleteFinetunesResponse,
  DeleteUsersData,
  DeleteUsersError,
  DeleteUsersResponse,
  DownloadItemsData,
  DownloadItemsError,
  DownloadItemsResponse,
  ExportItemsData,
  ExportItemsError,
  ExportItemsResponse,
  GenerateRationalesData,
  GenerateRationalesError,
  GenerateRationalesResponse,
  GetCustomerError,
  GetCustomerResponse,
  GetIntegrationData,
  GetIntegrationError,
  GetIntegrationResponse,
  GetItemMediaData,
  GetItemMediaError,
  GetItemMediaListData,
  GetItemMediaListError,
  GetItemMediaListResponse,
  GetItemMediaResponse,
  HealthzError,
  HealthzResponse,
  ImportFinetunesData,
  ImportFinetunesError,
  ImportFinetunesResponse,
  ListAiModelsError,
  ListAiModelsResponse,
  LoginCallback1Data,
  LoginCallback1Error,
  LoginCallback1Response,
  LoginCallbackData,
  LoginCallbackError,
  LoginCallbackResponse,
  PossibleKeysData,
  PossibleKeysError,
  PossibleKeysResponse,
  RemoveProjectData,
  RemoveProjectError,
  RemoveProjectResponse,
  ResetCustomerDataError,
  ResetCustomerDataResponse,
  ResetUserDataError,
  ResetUserDataResponse,
  RunBiasCheckData,
  RunBiasCheckError,
  RunBiasCheckResponse,
  SaveItemData,
  SaveItemError,
  SaveItemResponse,
  SearchReferencesData,
  SearchReferencesError,
  SearchReferencesResponse,
  SwitchCustomerData,
  SwitchCustomerError,
  SwitchCustomerResponse,
  TestIntegrationData,
  TestIntegrationError,
  TestIntegrationResponse,
  UpdateUserData,
  UpdateUserError,
  UpdateUserResponse,
  UploadMediaToItemData,
  UploadMediaToItemError,
  UploadMediaToItemResponse,
  UpsertIntegrationData,
  UpsertIntegrationError,
  UpsertIntegrationResponse,
} from './types.gen'

export const client = createClient(createConfig())

/**
 * Healthz
 */
export const healthz = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<HealthzResponse, HealthzError, ThrowOnError>({
    ...options,
    url: '/api/healthz',
  })
}

/**
 * List Ai Models
 */
export const listAiModels = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListAiModelsResponse, ListAiModelsError, ThrowOnError>({
    ...options,
    url: '/api/ai-models',
  })
}

/**
 * Create Ai Model
 */
export const createAiModel = <ThrowOnError extends boolean = false>(
  options: Options<CreateAiModelData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateAiModelResponse, CreateAiModelError, ThrowOnError>({
    ...options,
    url: '/api/ai-models',
  })
}

/**
 * Search References
 */
export const searchReferences = <ThrowOnError extends boolean = false>(
  options: Options<SearchReferencesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SearchReferencesResponse,
    SearchReferencesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/ai-models/{ai_model_id}/references',
  })
}

/**
 * Get Integration
 */
export const getIntegration = <ThrowOnError extends boolean = false>(
  options: Options<GetIntegrationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetIntegrationResponse, GetIntegrationError, ThrowOnError>(
    {
      ...options,
      url: '/api/internal/integrations/{integration_type}',
    },
  )
}

/**
 * Upsert Integration
 */
export const upsertIntegration = <ThrowOnError extends boolean = false>(
  options: Options<UpsertIntegrationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpsertIntegrationResponse,
    UpsertIntegrationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/integrations/{integration_type}',
  })
}

/**
 * Test Integration
 */
export const testIntegration = <ThrowOnError extends boolean = false>(
  options: Options<TestIntegrationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TestIntegrationResponse,
    TestIntegrationError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/integrations/{integration_type}/test',
  })
}

/**
 * Get Customer
 */
export const getCustomer = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetCustomerResponse, GetCustomerError, ThrowOnError>({
    ...options,
    url: '/api/customer',
  })
}

/**
 * Delete Finetunes
 */
export const deleteFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFinetunesData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteFinetunesResponse,
    DeleteFinetunesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/finetunes/{parent_name}',
  })
}

/**
 * Import Finetunes
 */
export const importFinetunes = <ThrowOnError extends boolean = false>(
  options: Options<ImportFinetunesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportFinetunesResponse,
    ImportFinetunesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/finetunes',
  })
}

/**
 * Switch Customer
 */
export const switchCustomer = <ThrowOnError extends boolean = false>(
  options: Options<SwitchCustomerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SwitchCustomerResponse,
    SwitchCustomerError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/switch-customers/{customer_id}',
  })
}

/**
 * Delete Auth0 Users
 */
export const deleteAuth0Users = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAuth0UsersData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteAuth0UsersResponse,
    DeleteAuth0UsersError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/gdpr_users',
  })
}

/**
 * Reset Customer Data
 */
export const resetCustomerData = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ResetCustomerDataResponse,
    ResetCustomerDataError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/reset-customer-data',
  })
}

/**
 * Reset User Data
 */
export const resetUserData = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ResetUserDataResponse, ResetUserDataError, ThrowOnError>({
    ...options,
    url: '/api/internal/reset-user-data',
  })
}

/**
 * Delete Ai Models
 */
export const deleteAiModels = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAiModelsData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteAiModelsResponse,
    DeleteAiModelsError,
    ThrowOnError
  >({
    ...options,
    url: '/api/internal/customers/{customer_name}/ai-models',
  })
}

/**
 * Clone Item
 */
export const cloneItem = <ThrowOnError extends boolean = false>(
  options: Options<CloneItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CloneItemResponse, CloneItemError, ThrowOnError>({
    ...options,
    url: '/api/items/{item_id}/clone',
  })
}

/**
 * Possible Keys
 */
export const possibleKeys = <ThrowOnError extends boolean = false>(
  options: Options<PossibleKeysData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<PossibleKeysResponse, PossibleKeysError, ThrowOnError>({
    ...options,
    url: '/api/items/{item_id}/possible-keys',
  })
}

/**
 * Save Item
 */
export const saveItem = <ThrowOnError extends boolean = false>(
  options: Options<SaveItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SaveItemResponse, SaveItemError, ThrowOnError>({
    ...options,
    url: '/api/items/{item_id}/save',
  })
}

/**
 * Generate Rationales
 */
export const generateRationales = <ThrowOnError extends boolean = false>(
  options: Options<GenerateRationalesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateRationalesResponse,
    GenerateRationalesError,
    ThrowOnError
  >({
    ...options,
    url: '/api/items/{item_id}/rationales',
  })
}

/**
 * Run Bias Check
 * Check permissions, send request to Skyline to check item bias and
 * update item content version with the bias results
 *
 * item_id: uuid!
 */
export const runBiasCheck = <ThrowOnError extends boolean = false>(
  options: Options<RunBiasCheckData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<RunBiasCheckResponse, RunBiasCheckError, ThrowOnError>({
    ...options,
    url: '/api/items/{item_id}/bias-check',
  })
}

/**
 * Export Items
 * Create an export job for given items.
 *
 * Parameters
 * ----------
 * project_ids: Optional[List[str]]
 * List of project IDs to export.
 * item_ids: Optional[List[str]]
 * List of item IDs to export.
 * export_type: str
 * File content type, e.g., 'qtiv2p1', 'txt'.
 * file_name: Optional[str]
 * The name of the exported file.
 *
 * Returns
 * -------
 * dict
 * job_id: str
 */
export const exportItems = <ThrowOnError extends boolean = false>(
  options: Options<ExportItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ExportItemsResponse, ExportItemsError, ThrowOnError>({
    ...options,
    url: '/api/exports',
  })
}

/**
 * Continue Export Job
 */
export const continueExportJob = <ThrowOnError extends boolean = false>(
  options: Options<ContinueExportJobData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ContinueExportJobResponse,
    ContinueExportJobError,
    ThrowOnError
  >({
    ...options,
    url: '/api/exports/{export_id}/continue',
  })
}

/**
 * Download Items
 * Download the exported items.
 *
 * Parameters
 * ----------
 * export_id: str
 * The ID of the export job.
 *
 * Returns
 * -------
 * dict
 * url: str
 */
export const downloadItems = <ThrowOnError extends boolean = false>(
  options: Options<DownloadItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<DownloadItemsResponse, DownloadItemsError, ThrowOnError>({
    ...options,
    url: '/api/exports/{export_id}/download-link',
  })
}

/**
 * Remove Project
 */
export const removeProject = <ThrowOnError extends boolean = false>(
  options: Options<RemoveProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RemoveProjectResponse,
    RemoveProjectError,
    ThrowOnError
  >({
    ...options,
    url: '/api/projects/{id}',
  })
}

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateUserResponse2, CreateUserError, ThrowOnError>({
    ...options,
    url: '/api/users',
  })
}

/**
 * Delete Users
 */
export const deleteUsers = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUsersData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<DeleteUsersResponse, DeleteUsersError, ThrowOnError>({
    ...options,
    url: '/api/users',
  })
}

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<UpdateUserResponse, UpdateUserError, ThrowOnError>({
    ...options,
    url: '/api/users/{user_id}',
  })
}

/**
 * Login Callback
 */
export const loginCallback = <ThrowOnError extends boolean = false>(
  options?: Options<LoginCallbackData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<LoginCallbackResponse, LoginCallbackError, ThrowOnError>({
    ...options,
    url: '/api/login-callback',
  })
}

/**
 * Login Callback
 */
export const loginCallback1 = <ThrowOnError extends boolean = false>(
  options?: Options<LoginCallback1Data, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    LoginCallback1Response,
    LoginCallback1Error,
    ThrowOnError
  >({
    ...options,
    url: '/api/login-callback',
  })
}

/**
 * Upload Media To Item
 */
export const uploadMediaToItem = <ThrowOnError extends boolean = false>(
  options: Options<UploadMediaToItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UploadMediaToItemResponse,
    UploadMediaToItemError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/api/items/{item_id}/media',
  })
}

/**
 * Get Item Media List
 */
export const getItemMediaList = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaListData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetItemMediaListResponse,
    GetItemMediaListError,
    ThrowOnError
  >({
    ...options,
    url: '/api/items/{item_id}/media',
  })
}

/**
 * Get Item Media
 */
export const getItemMedia = <ThrowOnError extends boolean = false>(
  options: Options<GetItemMediaData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetItemMediaResponse, GetItemMediaError, ThrowOnError>({
    ...options,
    url: '/api/items/{item_id}/media/{media_id}',
  })
}
